import { render, staticRenderFns } from "./customIcon.vue?vue&type=template&id=15fbec46&scoped=true"
import script from "./customIcon.vue?vue&type=script&lang=js"
export * from "./customIcon.vue?vue&type=script&lang=js"
import style0 from "./customIcon.vue?vue&type=style&index=0&id=15fbec46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15fbec46",
  null
  
)

export default component.exports